import firebase from "../firebase";

export default function({ officeId, personId, roomId, meaningButtonId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "messagingUser",
        funcName: "pageRoomToPerson",
        data: { officeId, personId, roomId, meaningButtonId }
    });
}
